import React from 'react';
import useInView from './useInView';

const certs = [
  { icon: '🏛', name: 'CAC Registration', sub: 'RC: 700638 · Corporate Affairs Commission' },
  { icon: '🛡', name: 'SCUML Certificate', sub: 'RN: SC 081734 · Anti-Money Laundering' },
  { icon: '📋', name: 'ITF Compliance', sub: 'IBA-003-5018 · Industrial Training Fund 2025–2026' },
  { icon: '⚖️', name: 'Stamp Duty Verified', sub: 'Cert. No: 2024-0752-23132-73939' },
  { icon: '✅', name: 'EFCC Registered', sub: '151615395 · Financial Compliance' },
];

export default function About() {
  const [leftRef, leftIn] = useInView();
  const [rightRef, rightIn] = useInView();

  return (
    <section id="about" style={{ padding: '8rem 0', background: 'white', overflow: 'hidden' }}>
      <div className="section-wrap">
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '6rem', alignItems: 'center' }}>

          {/* Left */}
          <div ref={leftRef} style={{ opacity: leftIn ? 1 : 0, transform: leftIn ? 'none' : 'translateX(-40px)', transition: 'all 0.8s ease' }}>
            <div className="section-label">Who We Are</div>
            <h2 className="section-title" style={{ marginBottom: '1.5rem' }}>
              An Indigenous<br /><span>Nigerian</span><br />Engineering Firm
            </h2>
            <p style={{ fontSize: '1.05rem', fontWeight: 400, lineHeight: 1.8, color: '#2a3a5c', marginBottom: '1.2rem' }}>
              Rigomich Integrated Company Limited is a fully indigenous construction firm incorporated under the Corporate Affairs Commission of Nigeria on <strong>25 July 2007</strong>. We render construction services to individuals, corporate bodies, and government organisations across Nigeria.
            </p>
            <p style={{ fontSize: '0.95rem', fontWeight: 300, lineHeight: 1.8, color: 'var(--grey)', marginBottom: '2rem' }}>
              We have consistently delivered quality and innovation in Civil/Building Construction, Water Engineering, Electrical & Mechanical installations, and General Contracting — becoming one of Nigeria's foremost construction companies, with advanced equipment and a team of 30+ experienced professionals.
            </p>
            <ul style={{ listStyle: 'none', marginBottom: '2.5rem' }}>
              {['Incorporated July 2007 — CAC RC: 700638', 'Offices in Abuja FCT and Osogbo, Osun State', 'Team of 30+ engineers and professionals', 'Advanced heavy equipment: excavators, bulldozers, drill rigs', 'Serving government, NGOs, corporations & private clients'].map((item, i) => (
                <li key={i} style={{
                  display: 'flex', alignItems: 'flex-start', gap: '0.8rem',
                  padding: '0.65rem 0', borderBottom: '1px solid #e8eef8',
                  fontSize: '0.92rem', fontWeight: 500, color: 'var(--blue-deep)',
                  opacity: leftIn ? 1 : 0, transition: `opacity 0.5s ease ${0.2 + i * 0.08}s`,
                }}>
                  <div style={{ width: 6, height: 6, background: 'var(--blue)', borderRadius: '50%', flexShrink: 0, marginTop: '0.45rem' }} />
                  {item}
                </li>
              ))}
            </ul>
            <a href="#contact" className="btn-primary"><span>Work With Us</span>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M5 12h14M12 5l7 7-7 7" /></svg>
            </a>
          </div>

          {/* Right */}
          <div ref={rightRef} style={{ opacity: rightIn ? 1 : 0, transform: rightIn ? 'none' : 'translateX(40px)', transition: 'all 0.8s ease 0.2s', position: 'relative' }}>
            {/* Image */}
            <div style={{ position: 'relative', overflow: 'visible' }}>
              <div style={{ background: 'var(--blue-deep)', aspectRatio: '4/3', overflow: 'hidden', position: 'relative' }}>
                <img src="https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=900&q=80&fit=crop&crop=center"
                  alt="Rigomich engineers on site"
                  style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block', transition: 'transform 0.6s ease' }}
                  onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.04)'}
                  onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
                />
                {/* Image overlay */}
                <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(135deg, rgba(26,79,156,0.2) 0%, transparent 60%)' }} />
              </div>
              {/* Decorative border */}
              <div style={{ position: 'absolute', top: -14, right: -14, width: '75%', height: '75%', border: '3px solid var(--blue)', zIndex: -1 }} />
              {/* Badge */}
              <div style={{
                position: 'absolute', bottom: -22, left: -22,
                background: 'var(--blue)', color: 'white', padding: '1.2rem 1.6rem', zIndex: 2,
              }}>
                <div style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: '2.4rem', lineHeight: 1 }}>18+</div>
                <div style={{ fontSize: '0.68rem', fontWeight: 600, letterSpacing: '0.1em', textTransform: 'uppercase', opacity: 0.9, lineHeight: 1.3 }}>Years of<br />Excellence</div>
              </div>
            </div>

            {/* Certs card */}
            <div style={{
              marginTop: '3.5rem',
              background: 'var(--blue-deep)',
              border: '1px solid rgba(26,79,156,0.3)',
              padding: '2rem',
            }}>
              <div className="section-label light" style={{ marginBottom: '1.2rem' }}>Certifications</div>
              {certs.map((c, i) => (
                <div key={i} style={{
                  display: 'flex', alignItems: 'center', gap: '1rem',
                  padding: '0.75rem 0',
                  borderBottom: i < certs.length - 1 ? '1px solid rgba(26,79,156,0.2)' : 'none',
                  opacity: rightIn ? 1 : 0, transition: `opacity 0.4s ease ${0.3 + i * 0.07}s`,
                }}>
                  <div style={{ width: 34, height: 34, background: 'rgba(26,79,156,0.3)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1rem', flexShrink: 0 }}>{c.icon}</div>
                  <div>
                    <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: '0.88rem', fontWeight: 700, color: 'white', letterSpacing: '0.04em' }}>{c.name}</div>
                    <div style={{ fontSize: '0.7rem', color: 'var(--silver)', fontWeight: 300, marginTop: 2 }}>{c.sub}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @media (max-width: 900px) {
          #about .section-wrap > div { grid-template-columns: 1fr !important; gap: 3rem !important; }
        }
      `}</style>
    </section>
  );
}
